import React, {Component} from 'react'
import Axios from 'axios'
import moment from 'moment';
import { Link } from 'react-router-dom';

class Cartela extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            numeros : [],
            cartelas: null,
            pedidos: null,
            gabaritos: [],
            
        }
        this.obterNumerosSorteados()
        this.getGabaritos()
    }

    async obterNumerosSorteados(e){
        try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/obter-numeros-sorteados", {});
            this.setState({numeros : response.data})
          } catch (err) {
            console.log(err);
          }
    }

    async getGabaritos(){
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.get("gabaritos/gabaritos-ativos");
        this.setState({ gabaritos: response.data });
      } catch (err) {
        console.log(err);
      }
    }

    marcarCartela(cartela,index){
      var isValid1 = 0;
      var isValid2 = 0;
      var isValid3 = 0;

      var kuadraPoints1 = 0;
      var kuadraPoints2 = 0;
      var kuadraPoints3 = 0;

      var isKuadra = (this.props.conferir == 'Kuadra');
      var isCruzadinha = false;
      var isCheia = false;

  
      var gabaritoKuadra = null;

      this.state.gabaritos.map(gabarito => {
        if(this.props.conferir == 'Linha' && gabarito.tipo == 'Linha' && cartela.codigo == gabarito.cartelaSorteada.codigo
        || this.props.conferir == 'Kina' && gabarito.tipo == 'Kina' && cartela.codigo == gabarito.cartelaSorteada.codigo
        ){

          gabarito.numeros.map(gNumero => {
            cartela.numeros.slice(0,5).map(cNumero => {
              if(cNumero == gNumero)
                isValid1++;
            })
            cartela.numeros.slice(5,10).map(cNumero => {
              if(cNumero == gNumero)
                isValid2++;
            })
            cartela.numeros.slice(10,15).map(cNumero => {
              if(cNumero == gNumero)
                isValid3++;
            })
          })
        }
        else if(this.props.conferir == 'Kuadra' && gabarito.tipo == 'Kuadra' && cartela.codigo == gabarito.cartelaSorteada.codigo){
          gabaritoKuadra = gabarito;
          gabarito.numeros.map(gNumero => {
            cartela.numeros.slice(0,5).map(cNumero => {
              if(cNumero == gNumero)
              kuadraPoints1++;
            })
            cartela.numeros.slice(5,10).map(cNumero => {
              if(cNumero == gNumero)
              kuadraPoints2++;
            })
            cartela.numeros.slice(10,15).map(cNumero => {
              if(cNumero == gNumero)
              kuadraPoints3++;
            })
          })
        }
        else if(this.props.conferir == 'Cruzadinha' && gabarito.tipo == 'Cruzadinha' && cartela.codigo == gabarito.cartelaSorteada.codigo){
          gabarito.numeros.map(gNumero => {
            isValid2 = 5;
            cartela.numeros.slice(0,5).map(cNumero => {
            if(index == 2 && isValid2 >= 4 && gNumero == cNumero){
              isCruzadinha = true
            }
          })
          cartela.numeros.slice(5,10).map(cNumero => {
            if(index == 12 && isValid2 >= 4 && gNumero == cNumero ){
              isCruzadinha = true
            }
          })
          })
        }
        else if(this.props.conferir == 'Cheia' && gabarito.tipo == 'Cheia' && cartela.codigo == gabarito.cartelaSorteada.codigo){
          isCheia = true;
        }

      })

      
      if(isCheia)return true
      if(isCruzadinha)return true
      if(isKuadra && gabaritoKuadra){
        if(index < 5 && kuadraPoints1 == 4 && gabaritoKuadra.numeros.includes(cartela.numeros[index])){
          return true;}
        else if(index >= 5 && index < 10 && kuadraPoints2 == 4 && gabaritoKuadra.numeros.includes(cartela.numeros[index])){
          return true;
        }
        else if(index >= 10 && index < 15 && kuadraPoints3 == 4 && gabaritoKuadra.numeros.includes(cartela.numeros[index])){
          return true;
        }
      }
      else{ 
        if(index < 5 && isValid1 == 5){
        return true;}
      else if(index >= 5 && index < 10 && isValid2 == 5){
        return true;
      }
      else if(index >= 10 && index < 15 && isValid3 == 5){
        return true;
      }
    }

      return false;

    }

    conferirColorir(cartelaNumero,cartelaIndex){
      var status = false;
      if(this.state.numeros.length > 0){
        status =  this.state.numeros.some(numero => numero == cartelaNumero)
      }
      if(status){
        var classe = "text-light bg-danger col";

        return classe 
      }
      else{
        return "col"
      }
    }


    formatDate(data) {
    return moment(data).add(0,'days').format('DD-MM-YYYY')
    }

    render(){

        return (
            <button
                   class="superContainer p-2"
                          > 
                            <div
                              class="card text-white bg-dark mb-3 shadow"
                              style={{zIndex: '1'}}
                            >
                              <div class="bg-dark card-header ">
                                <div class="container ">
                                  <div class="row">
                                    <div class="col">
                                      <div class="row">
                                        <span class="font-weight-bold">
                                          código : <Link class="text-danger">{this.props.cartela.codigo}</Link>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="col">
                                    <div class="row justify-content-end">
                                        <span class="font-weight-bold text-warning">
                                          Data do sorteio
                                        </span>
                                      </div>
                                      <div class="row justify-content-end">
                                        <span class="font-weight-bold">
                                          <Link class="text-light">{this.formatDate(this.props.cartela.data)}</Link>
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="bg-dark card-body justify-content-center ajustar">
                                <div
                                  class="bg-light rounded"
                                  style={{ width: "17.8em", height: "10em" }}
                                >  {this.props.cartela.numeros? 
                                
                                    <div class="container text-dark tracado tracado2">
                               <div class="row">
<div class={this.marcarCartela(this.props.cartela,0)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[0],0)}>
  <span >{this.props.cartela.numeros[0]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,1)? "text-light bg-success col" :this.conferirColorir(this.props.cartela.numeros[1],1)}>
  <span>{this.props.cartela.numeros[1]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,2)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[2],2)}>
  <span>{this.props.cartela.numeros[2]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,3)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[3],3)}>
  <span>{this.props.cartela.numeros[3]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,4)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[4],4)}>
  <span>{this.props.cartela.numeros[4]}</span>
</div>
</div>
<div class="row">
<div class={this.marcarCartela(this.props.cartela,5)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[5],5)}>
  <span>{this.props.cartela.numeros[5]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,6)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[6],6)}>
  <span>{this.props.cartela.numeros[6]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,7)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[7],7)}>
  <span>{this.props.cartela.numeros[7]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,8)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[8],8)}>
  <span>{this.props.cartela.numeros[8]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,9)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[9],9)}>
  <span>{this.props.cartela.numeros[9]}</span>
</div>
</div>
<div class="row">
<div class={this.marcarCartela(this.props.cartela,10)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[10],10)}>
  <span>{this.props.cartela.numeros[10]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,11)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[11],11)}>
  <span>{this.props.cartela.numeros[11]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,12)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[12],12)}>
  <span>{this.props.cartela.numeros[12]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,13)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[13],13)}>
  <span>{this.props.cartela.numeros[13]}</span>
</div>
<div class={this.marcarCartela(this.props.cartela,14)? "text-light bg-success col" : this.conferirColorir(this.props.cartela.numeros[14],14)}>
  <span>{this.props.cartela.numeros[14]}</span>
</div>
                                    </div>
                                  </div>
                                
                                : ""}
                                  
                                </div>
                              </div>
                            </div>
                          </button>
        );
    }

}

export default Cartela;